module.exports = __webpack_public_path__ + "static/media/grid-item-b4.b5b97a7d.png";